export const eur = (cents) => `${((cents || 0) / 100).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} €`;
export const toCents = (v) => Math.round((parseFloat(String(v ?? "").replace(",", ".")) || 0) * 100);
export const fromCents = (c) => (c ? String(c / 100).replace(".", ",") : "");
export const fmtD = (iso) => (iso ? new Date(iso + "T00:00:00").toLocaleDateString("fr-FR", { day: "2-digit", month: "short" }) : "—");
export const addDays = (iso, n) => { const x = new Date(iso + "T00:00:00Z"); x.setUTCDate(x.getUTCDate() + n); return x.toISOString().slice(0, 10); };
export const todayIso = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);

export const SOURCES = {
  airbnb: { label: "Airbnb", bar: "bg-rose-500", dot: "bg-rose-500" },
  booking: { label: "Booking", bar: "bg-blue-600", dot: "bg-blue-600" },
  abritel: { label: "Abritel", bar: "bg-amber-500", dot: "bg-amber-500" },
  direct: { label: "Direct", bar: "bg-emerald-600", dot: "bg-emerald-600" },
  manuel: { label: "Manuel", bar: "bg-brand-greenDeep", dot: "bg-brand-greenDeep" },
  autre: { label: "Autre", bar: "bg-slate-500", dot: "bg-slate-500" },
};
export const BLOCK_STYLE = "bg-[repeating-linear-gradient(45deg,#cbd5e1,#cbd5e1_6px,#e2e8f0_6px,#e2e8f0_12px)] text-slate-600";

export const STATUTS = {
  demande: { label: "Demande", cls: "bg-sky-100 text-sky-700" },
  option: { label: "Option", cls: "bg-violet-100 text-violet-700" },
  confirmee: { label: "Confirmée", cls: "bg-emerald-100 text-emerald-700" },
  en_cours: { label: "En cours", cls: "bg-brand-lime/50 text-brand-greenDeep" },
  terminee: { label: "Terminée", cls: "bg-slate-100 text-slate-600" },
  annulee: { label: "Annulée", cls: "bg-red-100 text-red-600" },
  bloquee: { label: "Bloquée", cls: "bg-slate-200 text-slate-600" },
};
export const PAIEMENTS = { non_paye: "Non payé", acompte: "Acompte", solde: "Soldé", rembourse: "Remboursé" };
export const COMPLIANCE = {
  conforme: { label: "Conforme", cls: "bg-emerald-100 text-emerald-700", dot: "bg-emerald-500" },
  a_faire: { label: "À faire", cls: "bg-amber-100 text-amber-700", dot: "bg-amber-500" },
  en_retard: { label: "En retard", cls: "bg-red-100 text-red-700", dot: "bg-red-500" },
};
export const NEXT_STATUTS = { demande: ["option", "confirmee", "annulee"], option: ["confirmee", "annulee"], confirmee: ["annulee"] };
export const inputCls = "w-full px-3 py-2.5 rounded-xl border border-brand-soft bg-white outline-none focus:border-brand-lime text-sm text-brand-greenDeep transition-colors";
export const labelCls = "block text-xs font-semibold text-brand-green/65 mb-1.5";
export const LEGAL = "Information, pas un conseil juridique. Les seuils légaux évoluent : vérifiez auprès de votre mairie.";
